import { render, staticRenderFns } from "./Self.vue?vue&type=template&id=5d145340&scoped=true"
import script from "./Self.vue?vue&type=script&lang=js"
export * from "./Self.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d145340",
  null
  
)

export default component.exports